import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import styled from 'foundations-theming/utils';
import { GAP } from '../../constants/inlineLayout';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { STANDARD_URL, UTM_URL, defaultUtmParameters, getFullUtmUrl } from '../../utils/urlUtils';
import FilterOperatorStandardUrlInput from './FilterOperatorStandardUrlInput';
import FilterOperatorUtmUrlInputResponsive from './FilterOperatorUtmUrlInputResponsive';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlexContainer = styled.div.withConfig({
  displayName: "FilterOperatorUrlEqualityInputResponsive__FlexContainer",
  componentId: "tqthgr-0"
})(["display:flex;gap:", "px;align-items:center;"], GAP);
export default function FilterOperatorUrlEqualityInputResponsive(props) {
  const {
    condition,
    error,
    onBlur,
    onChange,
    inputUse
  } = props;
  const {
    width
  } = useElementSize();
  const isUtmUrl = condition === null || condition === void 0 ? void 0 : condition.enableTracking;
  const urlType = isUtmUrl ? UTM_URL : STANDARD_URL;
  const standardUrl = !isUtmUrl && (condition === null || condition === void 0 ? void 0 : condition.value) || '';
  const utmUrl = isUtmUrl && (condition === null || condition === void 0 ? void 0 : condition.utmBase) || '';
  const utmParameters = isUtmUrl && (condition === null || condition === void 0 ? void 0 : condition.utmParameters) || defaultUtmParameters;
  const onChangeStandard = evt => {
    onChange(syntheticEvent(condition.set('value', evt.target.value)));
  };
  const onChangeUtm = evt => {
    const {
      urlBase: newUrl,
      utmParameters: newUtmParameters
    } = evt.target.value;
    onChange(syntheticEvent(condition.set('value', getFullUtmUrl(newUrl, newUtmParameters)).set('utmBase', newUrl).set('utmParameters', newUtmParameters)));
  };
  const onChangeUrlType = evt => {
    onChange(syntheticEvent(condition.set('value', '').set('enableTracking', evt.target.value === UTM_URL).set('utmBase', '').set('utmParameters', defaultUtmParameters)));
  };
  const sharedProps = {
    error,
    onBlur,
    inputUse
  };
  const InputContainer = width.size === MEDIA_SIZES.sm ? 'div' : FlexContainer;
  return /*#__PURE__*/_jsxs(InputContainer, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        width: 'auto'
      },
      children: /*#__PURE__*/_jsx(UISelect, {
        buttonUse: "transparent",
        options: [{
          text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorUrlEqualityInput.standard'),
          value: STANDARD_URL
        }, {
          text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorUrlEqualityInput.utm'),
          value: UTM_URL
        }],
        onChange: onChangeUrlType,
        value: urlType
      })
    }), urlType === STANDARD_URL ? /*#__PURE__*/_jsx(FilterOperatorStandardUrlInput, Object.assign({}, sharedProps, {
      onChange: onChangeStandard,
      value: standardUrl
    })) : /*#__PURE__*/_jsx(FilterOperatorUtmUrlInputResponsive, Object.assign({}, sharedProps, {
      onChange: onChangeUtm,
      value: {
        urlBase: utmUrl,
        utmParameters
      }
    }))]
  });
}